import React, { createPortal } from 'preact/compat';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util from "../util";
import { h, Component } from 'preact';
import constants from '../constants';
import PaintBrushIcon from './icon/PaintBrushIcon';
import UploadIcon from './icon/UploadIcon';
import DataManagerService from '../service/DataManagerService';
import Spinner from './Spinner';
import { PdfDataReview } from './PdfDataReview';
import { PdfMatch } from './PdfMatch';
import { PopMenuImport } from './PopMenuImport';
import MenuObject, { addDisplayPrices } from '../canvas/menu-object';
import PosIcon from "./icon/PosIcon";
import { PosMenuImport } from "./PosMenuImport";
import DataLibraryMenuSection from "./DataLibraryMenuSection";
import { ConflictSections } from "./ConflictSections";
import store from '../store';
import { setMenuGroups, setMenuGroupsSource } from '../actions';
import { updateMenuGroup } from '../service/menuGroupService';
import posService from '../service/posService';
import { BarsOutlined, CheckOutlined, CloseOutlined, LeftOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import MenuContentDesigns from "./MenuContentDesigns";
import MenuContentImport from "./MenuContentImport";
import { markAsModified } from '../canvas/mark-as-modified';
import designDomain from '../domain/designDomain';
import { addComponent, VIEWPORT_CENTER } from '../canvas/component';
import MOImportIcon from "./svg/MOImportIcon";
import ooService from '../service/ooService';
import aiService from "../service/aiService";
import AiOnboarder from "./AiOnboarder";
import ItemLibraryIcon from "./icon/ItemLibraryIcon";
import { getItemLibraryProps } from "../service/dataLibraryService";
import ItemLibraryIconInverted from "./icon/ItemLibraryIconInverted";
import BarsIcon from "./svg/BarsIcon";
import FilePdfIcon from "./svg/FilePdfIcon";

export const View = {
  General: "general",
  Pdf: "pdf",
  PdfMatch: "pdf-match",
  PdfReview: "pdf-review",
  Pop: "pop",
  Pos: "pos",
  Conflict: "conflict",
  Designs: 'designs',
  Import: 'import',
  OmImport: 'om-import',
  SelectOm: 'select-om',
  AiOnboarder: 'ai-onboarder',
  ItemLibrary: 'item-library',
};

const Mode = {
  Light: "light",
  Advanced: "advanced"
}

export const ConflictDecision = {
  Replace: "replace",
  Append: "append",
  New: "new"
}

export default @connect(reduce, actions)
class DataLibrary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: Mode.Light,
      menus: [],
      source: "",
      searchKey: "",
      draftSections: [],
      finalSections: [],
      view: View.General,
      isPdfUploading: false,
      pdfPages: [],
      pdfMatches: [],
      conflictSections: [],

      items: [],
      onlineMenus: [],
      onlineMenuId: '',
      onlineMenuName: '',
      businessName: '',
      onlineMenuUrl: '',
      importFromSampleCopy: false,
      isItemLibraryImport: false,
      itemLibraryEmpty: false
    };

    document.addEventListener("goToPos", async () => {
      this.goToPos();
    });

    document.addEventListener("goToItemLibraryView", async () => {
      this.goToItemLibrary();
    });

    document.addEventListener("goToItemLibraryViewWithMenus", async (e) => {
      this.handleItemLibraryMenus(e.detail.menus);
    });
  }

  componentDidMount() {
    this.populateOnlineMenus();
    this.populateOnlineMenusBusinessName();
  }

  populateOnlineMenus() {
    this.setState({ onlineMenus: [] });

    ooService.getMenus(this.props.memberId, this.props.locationId)
      .then(onlineMenusResponse => {
        if (onlineMenusResponse.status === 200) {
          this.setState({ onlineMenus: onlineMenusResponse.data });
        }
      });
  }

  populateOnlineMenusBusinessName() {
    this.setState({ businessName: '' });

    ooService.getBusiness(this.props.memberId, this.props.locationId)
      .then(businessResponse => {
        if (businessResponse.status === 200) {
          this.setState({
            businessName: businessResponse.data.name,
            onlineMenuUrl: businessResponse.data.url
          });
        }
      });
  }

  goToPdf() {
    this.setState({ view: View.Pdf });
  }

  goToPop() {
    this.setState({ view: View.Pop });
  }

  openSavedDesigns() {
    this.setState({ view: View.Designs });
  }

  goToOM() {
    this.setState({ view: View.SelectOm });
  }

  goToAi() {
    this.setState({ view: View.AiOnboarder });
  }

  goToSavedDesigns() {
    window.ItemLibrary.Lib.show({
      ...getItemLibraryProps(),
      source: 'import',
      onImportBtnClicked: (menus) => {
        window.ItemLibrary.Lib.hide();
        store.dispatch(actions.setIsDataLibraryModal(true));
        document.dispatchEvent(new Event("goToItemLibraryView"));
      },
      onAddToDesign: (menus) => {
        window.ItemLibrary.Lib.hide();
        this.handleItemLibraryMenus(menus);
      }
    });
  }

  openItemLibraryModal() {
    this.setState({
      view: View.ItemLibrary
    });
    window.ItemLibrary.Lib.getPublishedMenus(getItemLibraryProps()).then((menus) => {
      this.handleItemLibraryMenus(menus);
    });
  }

  handleItemLibraryMenus(menus) {
    const source = 'itemlibrary';
    const locationName = window.data.locations.find(it => it.internalId === window.data.design.locationId)?.name || '';

    const mapped = menus
      .filter(it => it.sections.filter(it => !it.removed).length > 0 && !it.removed)
      .map(menu => posService.mapMenu(menu, source, locationName, '', true))
      .sort((a, b) => (a.updatedDate?.getTime() ?? 0) - (b.updatedDate?.getTime() ?? 0));

    mapped.forEach((it, idx) => {
      it.sequence = idx + 1;
    });

    if (mapped.length) {
      this.setState({
        isItemLibraryImport: true,
        source,
        menus: mapped,
        view: View.General
      });
    } else {
      this.setState({
        itemLibraryEmpty: true,
      });
    }
  }

  ilCreateNewMenu() {
    this.onClose();
    if (!this.props.hasPdfPermission) {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
      return;
    }
    window.ItemLibrary.Lib.show({
      ...getItemLibraryProps(),
      createNewMenu: true,
      onImportBtnClicked: (menus) => {
        window.ItemLibrary.Lib.hide();
        store.dispatch(actions.setIsDataLibraryModal(true));
        document.dispatchEvent(new Event("goToItemLibraryView"));
      },
      onAddToDesign: (menus) => {
        window.ItemLibrary.Lib.hide();
        this.handleItemLibraryMenus(menus);
      }
    });
  }

  goToItemLibrary() {
    this.openItemLibraryModal();
  }

  goToPos() {
    if (!this.props.hasPdfPermission) {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
      return;
    }

    function showPosMenus(this1) {
      this1.setState({ view: View.Pos, isItemLibraryImport: false });
      this1.toggleMobileDropdown();
    }

    const this1 = this;
    if (store.getState().isSquare || store.getState().isClover || store.getState().isTreez || store.getState().isPopmenu) {
      showPosMenus(this1);
    } else {
      posService.isToastLinked(window.data.member.id).then(resp => {
        if (resp.data) {
          showPosMenus(this1);
        } else {
          store.dispatch(actions.setIsPosConnectModal(true));
          this.onClose();
        }
      });
    }
  }

  goToConflict() {
    this.setState({ view: View.Conflict });
  }

  onClose() {
    this.props.onModalClose();
  }

  validatePdfType(file) {
    let isValid = false;
    const fileType = file.type.toLowerCase();
    if (fileType === "application/pdf") {
      isValid = true;
    }
    if (!isValid) {
      window.InfoModal.show({
        title: 'File type not supported!',
        body: 'Only PDFs are supported.',
        acceptLabel: 'Got it',
      });
    }
    return isValid;
  }

  onPdfChange(event) {
    const { files } = event.target;
    const data = new FormData();
    if (files.length !== 1) return;
    if (!this.validatePdfType(files[0])) {
      return;
    }

    data.append("file", files[0], files[0].name)
    this.setState({
      isPdfUploading: true,
    });

    DataManagerService.analyze(data).then(async resp => {
      const json = await resp.json();
      this.setState({
        isPdfUploading: false,
        pdfPages: json.pages,
        pdfMatches: json.matches,
        view: View.PdfMatch
      })
    });
  }

  addFinalSection(section) {
    const draft = this.state.draftSections.filter(it => it.name !== section.name);
    const final = [...this.state.finalSections, section];

    this.setState({
      draftSections: draft,
      finalSections: final
    })
  }

  addFinalItem(item) {
    const final = [...this.state.finalSections];
    if (final.length === 0) {
      final.push({
        active: true,
        name: "",
        description: "",
        items: []
      });
    }

    const section = final.find(it => it.active);
    section.items.push(item);

    const draft = [...this.state.draftSections];
    draft.forEach(section => {
      section.items = section.items.filter(it => it.name !== item.name);
    })

    this.setState({
      finalSections: final,
      draftSections: draft
    });
  }

  parsePdf() {
    const { pdfPages, pdfMatches } = this.state;
    const draft = DataManagerService.getPdfItems(pdfPages, pdfMatches);
    this.setState({
      view: View.PdfReview,
      draftSections: draft
    });
  }

  replaceAllMockData() {
    MenuObject.fullyReplaceContent(this.state.draftSections);
  }

  selectSection(section) {
    if (section.items.length > 0) {
      section.checked = !section.checked;
      this.setState({
        menus: this.state.menus
      });
    }
  }

  selectAllSections(menu) {
    let isAllChecked = this.isAllSubsectionsChecked(menu);
    this.selectAll(menu, !isAllChecked);
    this.setState({
      menus: this.state.menus
    });
  }

  isAllSubsectionsChecked(section) {
    if (section.items && section.items.length > 0 && !section.checked) {
      return false;
    } else if (section.sections.length > 0) {
      let secMap = section.sections.map(sec => {
        return this.isAllSubsectionsChecked(sec);
      })
      if (secMap.some(bool => {
        return !bool
      })) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  selectAll(section, select) {
    section.sections.forEach(sec => {
      if (sec.items.length > 0) {
        sec.checked = select;
      }

      if (sec.sections.length) {
        this.selectAll(sec, select);
      }
    });
  }

  groupToastSections(sections) {
    let grouped = [];

    sections.forEach(s => {
      const menu = this.state.menus.find(it => it.id === s.menuId);
      const breadcrumbs = this.findSectionBreadcrumbs(menu.sections, s);
      breadcrumbs.length = Math.min(breadcrumbs.length, 2);
      const rev = breadcrumbs.reverse();
      const name = rev.map(it => it.name).join(' ');
      const existing = grouped.find(it => it && (it.name === name));

      if (!existing) {
        s.name = name;
        grouped.push(s);
      } else {
        existing.items = [...existing.items, ...s.items];
      }
    });

    return grouped;
  }

  findSectionBreadcrumbs(sections, section) {
    for (let i = 0; i < sections.length; i++) {
      const cur = sections[i];
      if (cur.id === section.id) return [{ id: cur.id, name: cur.name }];

      if (cur.sections) {
        const foundIds = this.findSectionBreadcrumbs(cur.sections, section);
        if (foundIds) {
          foundIds.push({ id: cur.id, name: cur.name });
          return foundIds;
        }
      }
    }
  }

  addGroups() {
    let sections = [];

    function appendSections(s) {
      s.forEach(section => {
        if (section.checked) {
          sections.push(section);
        }
        if (section.sections?.length) {
          appendSections(section.sections);
        }
      });
    }

    this.state.menus.forEach(menu => appendSections(menu.sections));

    if (sections[0].source === constants.IMPORT_SOURCE_TOAST) {
      sections = this.groupToastSections(sections);
    }

    const oldSections = this.props.menuGroups;
    const conflictSections = sections.filter(s => oldSections.find(it => it.name === s.name));
    this.setState({
      conflictSections,
      draftSections: sections
    });

    if (!conflictSections.length) {
      this.onSuccess([...oldSections, ...sections]);
    } else {
      this.goToConflict();
    }
  }

  onSuccess(sections) {
    sections = sections.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    sections.forEach(s => {
      s.items = s.items.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
    });

    if (!$('#design-cfg').attr('legacy-mmgs-removed')) {
      sections = sections.filter((sec) => {
        return sec.source === "toast" || sec.source === "square" || sec.source === 'treez' || sec.source === 'popmenu' || sec.source === 'itemlibrary';
      })
      $('#design-cfg').attr('legacy-mmgs-removed', 'true');
    }

    store.dispatch(setMenuGroups(sections));
    store.dispatch(setMenuGroupsSource(this.state.source));

    setTimeout(() => {
      $('#mmg-aside-title').trigger('click');
    }, 100);

    updateMenuGroup({
      designId: this.props.designId,
      memberId: this.props.memberId,
      source: this.state.source,
      data: JSON.stringify(sections)
    }).then();

    this.setState({
      menus: []
    });
    this.props.onModalClose();
  }

  onConflictModalClose() {
    this.onClose();
  }

  onConflictResolved(result) {
    const sections = [];

    let oldSections = this.props.menuGroups;

    this.state.draftSections.forEach(s => {
      const decision = result[s.id];
      if (decision) {
        const oldSection = oldSections.find(o => o.name === s.name);

        switch (decision) {
          case ConflictDecision.Replace: {
            oldSections = oldSections.filter(o => o.name !== s.name);
            oldSections.push(s);
            break;
          }
          case ConflictDecision.New: {
            s.id += '-copy';
            oldSections.push(s);
            break;
          }
          case ConflictDecision.Append: {
            s.items.forEach(i => {
              if (!oldSection.items.find(it => it.id === i.id)) {
                oldSection.items.push(i);
              }
            });
            break;
          }
          default: {
            console.error('=> Conflict decision not handled', decision);
          }
        }
      } else {
        oldSections.push(s);
      }
    });

    this.onSuccess(oldSections);
    this.goToPos();
  }

  unlinkToast() {
    posService.unlinkToast(window.data.member.id).then(() => {
      console.log('unlinked');
      this.onClose();
    }).catch(() => {
      console.log("error unlinking");
    })
  }

  toggleMobileDropdown() {
    const $dropdown = $('.mobile-import-dropdown');
    $dropdown.toggleClass('show');
  }

  newMenuObject() {
    store.dispatch(actions.deselect());

    const mo = new designDomain.MenuObject({
      config: MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE,
      content: '[{"name":"","description":"","prices":[]}]'
    });
    const html = MenuObject.getHtmlContent(mo.content, mo.config);

    const $page = util.getPageInViewport($('.page'));
    addComponent($page.attr('id'), html, {
      position: {
        left: VIEWPORT_CENTER,
        top: VIEWPORT_CENTER
      },
      isFromTemplate: true,
      keepColors: true
    });

    const items = [new MenuObject.MenuItem()];
    store.dispatch(actions.setMenuObjectItems(items));

    this.setState({
      items,
      activeIdx: 0,
      isEditMode: true,
      scrollToBottomSectionId: true,
    });
  }

  goToDesigns() {
    this.props.setMenuObjectImportDesign(null);
    this.props.setMenuObjectImportName('');
    this.props.setOnlineMenuImport(null);
    this.setState({
      view: View.Designs
    });
  }

  goToImport() {
    this.setState({
      view: View.Import
    });
  }

  selectDesign(id, name) {
    this.resetSelectedOnlineMenu();
    this.props.setMenuObjectImportDesign(id);
    this.props.setMenuObjectImportName(name);
    this.goToImport();
  }

  resetSelectedOnlineMenu() {
    this.props.setOnlineMenuImport(null);
  }

  goToSelectOM() {
    this.setState({
      view: View.SelectOm
    });
  }

  onOnlineMenuClick(menu, ev) {
    this.props.setOnlineMenuImport(menu);
    const menus = [...this.state.onlineMenus];
    menus.forEach(it => it.selected = it.id === menu.id);
    this.setState({
      menu,
      onlineMenuId: menu.id,
      onlineMenuName: menu.name,
      view: View.OmImport
    });
  }

  selectOnlineMenu(menu) {
    this.props.setOnlineMenuImport(menu);
    this.goToImportOnlineMenu(menu);
  }

  goToImportOnlineMenu(onlineMenu) {
    this.setState({
      onlineMenu,
      view: View.SelectOm
    });
  }

  selectLocation(id) {
    this.props.setMenuObjectImportLocation(id);
  }

  onSampleDataToggle() {
    this.setState({ importFromSampleCopy: !this.state.importFromSampleCopy });
  }

  removeDefaultDesign() {
    if (this.state.view === View.OmImport) {
      this.goToSelectOM();
    } else {
      this.goToDesigns();
    }
  }

  importItems(imported) {
    console.log(imported);
    markAsModified();

    let $element = this.props.$element;
    const defaultConfig = MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE;
    imported = [...addDisplayPrices(imported, JSON.parse(defaultConfig)['hide-trailing-zeroes'])];

    if (!$element || !MenuObject.isMenuObject($element)) {
      const mo = new designDomain.MenuObject({
        config: defaultConfig,
        content: JSON.stringify(imported)
      });
      const html = MenuObject.getHtmlContent(mo.content, mo.config);

      const $page = util.getPageInViewport($('.page'));
      addComponent($page.attr('id'), html, {
        position: {
          left: VIEWPORT_CENTER,
          top: VIEWPORT_CENTER
        },
        isFromTemplate: true,
        keepColors: true
      });

      if (store.getState().isMobileVersion) {
        store.dispatch(actions.setIsMobileAside(true));
      } else {
        this.setState({
          items: imported,
          isEditMode: true
        });
      }

      return;
    }

    const items = [...store.getState().menuObjectItems, ...imported];
    MenuObject.updateContent($element, items);

    if (!store.getState().isMobileVersion) {
      this.setState({
        items,
        isEditMode: true,
        view: View.Import
      });
      store.dispatch(actions.setMenuObjectItems(items));
      store.dispatch(actions.setMoSelectedItemIdx(items.length - 1));
    }
  }

  manualOpenPOSTourModal() {
    store.dispatch(actions.setIsPOSTourModal(true));
    store.dispatch(actions.setIsDataLibraryModal(false));
  }

  render(props, state) {
    return props.open ? createPortal(<div className={"data-library"}>
      <div className="modal-back" onClick={this.onClose.bind(this)} />
      <div className="modal data-library-modal" onClick={e => e.stopPropagation()}>
        <header className={"mn"}>
          <div className={"ops"}>
            <h3>Import new</h3>

            {props.isMobileVersion &&
              <div className="mobile-close" onClick={this.onClose.bind(this)}>
                <CloseOutlined />
              </div>}

            <button className={"btn secondary2"} onClick={this.openSavedDesigns.bind(this)}>
              <PaintBrushIcon />
              Saved Design
            </button>

            <button className={"btn secondary2"} onClick={this.goToPos.bind(this)}>
              <PosIcon />
              POS
            </button>

            <button className={"btn secondary2"} onClick={this.goToItemLibrary.bind(this)}>
              <ItemLibraryIcon />
              Item Library
            </button>

            {/*<a className={"saved-design"} onClick={this.goToSavedDesigns.bind(this)}>*/}
            {/*  <PaintBrushIcon />*/}
            {/*  Saved Design*/}
            {/*</a>*/}

            {/*<button className={"btn secondary2"} onClick={this.goToAi.bind(this)}>
            PDF / Menu Photo
            <span className={"beta"}>Beta</span>
          </button>*/}
            {/* <button className={"btn secondary2"} onClick={this.goToPdf.bind(this)}> */}
            {/*   <PdfIcon /> */}
            {/*   PDF */}
            {/* </button> */}

            {/*<button className={"btn secondary2"} onClick={this.goToOM.bind(this)}>*/}
            {/*  <OnlineMenuIcon />*/}
            {/*  Online Menu*/}
            {/*</button>*/}

            {/*(constants.isTestEnv || constants.isStageEnv) &&
          <button className={"btn secondary2"} onClick={this.unlinkToast.bind(this)}>
            Unlink Toast email (test only)
          </button>*/}
          </div>
        </header>
        {(state.view === View.Pos || (state.view === View.General && state.menus.length > 0 && !state.isItemLibraryImport)) &&
          <PosMenuImport
            toastEmail={props.toastEmail}
            isClover={props.isClover}
            isSquare={props.isSquare}
            isTreez={props.isTreez}
            isPopmenu={props.isPopmenu}
            onSuccess={(menus, source) => this.setState({
              source,
              menus,
              view: View.General,
              isItemLibraryImport: false
            })}
          />}

        {state.view === View.AiOnboarder &&
          <AiOnboarder
            onClose={this.onClose.bind(this)}
            importItems={this.importItems.bind(this)}
          />
        }

        {(state.view === View.General || (state.view === View.Pos && state.menus.length > 0)) &&
          <section className={`main ${this.state.mode === Mode.Light ? "light" : "advanced"} ${this.state.isItemLibraryImport ? 'from-il' : ''}`}>
            {state.mode === Mode.Light && <div className={"left"}>
              {state.menus.length === 0 && state.view !== View.Pos &&
                <h2 className={"placeholder"} style={"margin-top: 150px;"}>
                  <MOImportIcon fill="#999" /><br />
                  Choose an import option above to get started.
                </h2>}
              {state.menus.length > 0 &&
                <ul className={"mmn"}>
                  {state.menus.sort((a, b) => (a.sequence || 0) - (b.sequence || 0)).map(menu => <li>
                    <header>
                      <h5>{menu.name}</h5>
                      <h6>{menu.source} {menu.toastLocationName && <span>({menu.toastLocationName})</span>}</h6>
                      {!!menu.sections.length && <div
                        className={`check-all ${this.isAllSubsectionsChecked(menu) ? 'checked' : 'unchecked'}`}
                        onClick={() => this.selectAllSections.bind(this)(menu)}>
                        <CheckOutlined />
                      </div>}
                    </header>
                    {!menu.sections.length &&
                      <div class="no-data-message">
                        <p>No data in this menu</p>
                      </div>}
                    <DataLibraryMenuSection
                      sections={menu.sections}
                      selectSection={this.selectSection.bind(this)}
                      isAllSubsectionsChecked={this.isAllSubsectionsChecked.bind(this)}
                      selectAllSections={this.selectAllSections.bind(this)}
                      searchKey={this.state.searchKey.toLowerCase()}
                    />
                  </li>)}
                </ul>}
            </div>}

            {state.menus.length > 0 && <footer className={"mn"}>
              <div className="open-tour-btn" onClick={() => this.manualOpenPOSTourModal()}><QuestionCircleOutlined />
              </div>
              <button className={"btn primary medium"} onClick={this.addGroups.bind(this)}>
                Add groups
              </button>
            </footer>}
          </section>}

        {state.view === View.Pop &&
          <PopMenuImport
            onSuccess={(menus, source) => this.setState({
              menus,
              source,
              view: View.General
            })
            }
          />}

        {state.view === View.Pdf && <div className="dl-section-container">
          {!state.isPdfUploading &&
            <div className={"upload-wrap"}>
              <div className={"upload"}>
                <input type="file" name="file"
                  onChange={this.onPdfChange.bind(this)} accept="application/pdf" className="input-file" multiple />
                <div>
                  <UploadIcon />
                  <p>
                    Drag and drop files here or <br />
                    <a>select file from your computer</a>
                  </p>

                  <label>Text-based PDF, 400MB max</label>
                </div>
              </div>
            </div>}
          {state.isPdfUploading && <Spinner />}
        </div>}

        {state.view === View.PdfMatch &&
          <PdfMatch
            analyze={this.parsePdf.bind(this)}
            matches={this.state.pdfMatches}
            onChange={(it, value) => {
              it.type = value
            }}
          />}

        {state.view === View.PdfReview &&
          <PdfDataReview
            sections={state.draftSections}
            onChange={draftSections => this.setState({ draftSections })}
            onNext={draftSections => {
              this.setState({
                draftSections,
                view: View.General
              });
            }}
          />}

        {state.view === View.Conflict &&
          <ConflictSections
            conflictSections={this.state.conflictSections}
            onResolved={this.onConflictResolved.bind(this)}
            onClose={this.onConflictModalClose.bind(this)}
          />}

        {state.view === View.Designs &&
          <MenuContentDesigns
            $element={this.props.$element}
            isAdmin={props.isAdmin}
            isDesigner={props.isDesigner}
            isLogged={props.isLogged}
            locationId={props.locationId}
            designId={props.menuObjectImportDesign}
            memberId={props.memberId}
            newMenuObject={this.newMenuObject.bind(this)}
            onGoBack={this.goToDesigns.bind(this)}
            onClose={this.onClose.bind(this)}
            onFullClose={this.onClose.bind(this)}
            onSelectDesign={this.selectDesign.bind(this)}
            onSelectOnlineMenu={this.selectOnlineMenu.bind(this)}
            onSelectLocation={this.selectLocation.bind(this)}
            subview={state.view}
            importFromSampleCopy={this.state.importFromSampleCopy}
            onSampleDataToggle={this.onSampleDataToggle.bind(this)}
            onlineMenus={this.state.onlineMenus}
            onlineMenuUrl={this.state.onlineMenuUrl}
            menuObjectImportDesign={props.menuObjectImportDesign}
            menuObjectImportName={props.menuObjectImportName}
            onlineMenuImport={props.onlineMenuImport}
            isMobileVersion={props.isMobileVersion} />
        }

        {(state.view === View.Import || state.view === View.OmImport) && <MenuContentImport
          onGoBack={this.removeDefaultDesign.bind(this)}
          onClose={this.onClose.bind(this)}
          designId={props.menuObjectImportDesign}
          designName={props.menuObjectImportName}
          onlineMenuImport={props.onlineMenuImport}
          addItems={this.importItems.bind(this)}
          importFromSampleCopy={this.state.importFromSampleCopy}
        />}

        {state.view === View.SelectOm &&
          <div className="import-from-saved-designs">
            <header>
              <div className="go-back-btn" onClick={() => this.goToDesigns()}>
                <LeftOutlined />
              </div>
              <div className="top-content">
                <h4>{`Online Menus for ${state.businessName}`}</h4>
              </div>
              <p>Select a menu</p>
            </header>
            {state.isLoading ? <Spinner /> :
              <div className="modal-content import-items-content scroller">
                <ul className="online-menus">
                  {state.onlineMenus.map(menu => {
                    return <li onClick={(ev) => this.onOnlineMenuClick.bind(this)(menu, ev)}><span>{menu.name}</span>
                    </li>;
                  })}
                </ul>
              </div>}
          </div>
        }

        {state.view === View.ItemLibrary &&
          <div className={'import-from-item-library'}>
            {!state.itemLibraryEmpty && <Spinner />}
            {state.itemLibraryEmpty && <div>
              <div className={'no-item-library-available'}>
                <ItemLibraryIconInverted />
                <span>No Item Library data available</span>
                <div className={'options'}>
                  <button className={"btn secondary5"} onClick={this.goToPos.bind(this)}><BarsIcon /> Connect your POS</button>
                  {/*<button className={"btn secondary5"}><FilePdfIcon/> Upload PDF</button>*/}
                  <button className={"btn secondary5"} onClick={this.ilCreateNewMenu.bind(this)}>+ Create new menu</button>
                </div>
              </div>
            </div>}
          </div>
        }
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
